import { getCompanyCodeFromToken } from "./authService";
import { API_URL } from "./apiConfig";

const companyCode = getCompanyCodeFromToken();

export const fetchApprovalLevels = async () => {
  try {
    const response = await fetch(`${API_URL}Approvals/GetApprovalLevelsAsync/${companyCode}`);
    if (!response.ok) throw new Error("Failed to fetch approval levels");
    return await response.json();
  } catch (error) {
    console.error("Error fetching approval levels:", error);
    return [];
  }
};

export const fetchUserRoles = async () => {
  try {
    const response = await fetch(`${API_URL}Approvals/GetUserRolesAsync`);
    if (!response.ok) throw new Error("Failed to fetch user roles");
    return await response.json();
  } catch (error) {
    console.error("Error fetching user roles:", error);
    return [];
  }
};

export const addApprovalLevel = async (newRequest) => {
  try {
    newRequest.compCode = companyCode;
    const response = await fetch(`${API_URL}Approvals/AddApprovalLevel`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(newRequest),
    });
    if (response.ok) return await response.json();
    return { status: response.status };
  } catch (error) {
    console.error("API call failed:", error);
    throw error;
  }
};

export const updateApprovalLevel = async (newRequest) => {
  try {
    const response = await fetch(`${API_URL}Approvals/UpdateApprovalLevelAsync`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(newRequest),
    });
    if (response.ok) return await response.json();
    return { status: response.status };
  } catch (error) {
    console.error("API call failed:", error);
    throw error;
  }
};

export const deleteApprovalLevel = async (approval_level_id) => {
  try {
    const response = await fetch(`${API_URL}Approvals/DeleteApprovalLevel/${approval_level_id}`, {
      method: 'DELETE',
    });
    if (response.ok) return await response.json();
    return { status: response.status };
  } catch (error) {
    console.error("API call failed:", error);
    throw error;
  }
};

export const toggleApprovalLevelStatus = async (approval_level_id, is_active) => {
  try {
    const response = await fetch(
      `${API_URL}Approvals/ToggleApprovalLevelStatus/${approval_level_id}/${is_active}`,
      { method: "POST" }
    );
    if (response.ok) return await response.json();
    return { status: response.status };
  } catch (error) {
    console.error("API call failed:", error);
    throw error;
  }
};

export const SendForApproval = async (newRequest) => {
  try {
    const response = await fetch(`${API_URL}Approvals/SendForApprovel`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(newRequest),
    });
    if (response.ok) return await response.json();
    throw new Error('Failed to send for approval');
  } catch (error) {
    console.error("API call failed:", error);
    throw error;
  }
};

export const InsertHiringPackage = async (newRequest) => {
  try {
    const response = await fetch(`${API_URL}Approvals/InsertHiringPackage`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(newRequest),
    });
    if (response.ok) return await response.json();
    return { status: response.status };
  } catch (error) {
    console.error("API call failed:", error);
    throw error;
  }
};

export const UpdateHiringPackage = async (newRequest) => {
  try {
    const response = await fetch(`${API_URL}Approvals/UpdateHiringPackage`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(newRequest),
    });
    if (response.ok) return await response.json();
    return { status: response.status };
  } catch (error) {
    console.error("API call failed:", error);
    throw error;
  }
};

export const InsertApprovalLevel = async (newRequest) => {
  try {
    const response = await fetch(`${API_URL}Approvals/UpdateCandidateWithApprovalLevel`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(newRequest),
    });
    if (response.ok) return await response.json();
    return { status: response.status };
  } catch (error) {
    console.error("API call failed:", error);
    throw error;
  }
};

export const initialApproval = async (requestBody) => {
  try {
    const response = await fetch(`${API_URL}Approvals/InitialApproval`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(requestBody),
    });
    if (response.ok) return await response.json();
    return { status: response.status };
  } catch (error) {
    console.error("Initial approval API call failed:", error);
    throw error;
  }
};
